// src/components/personal/sections/SettingsSection/settingsUtils.ts

/**
 * Проверяет, есть ли изменения между текущим и оригинальным объектами
 */
export function hasChanges<T>(current: T, original: T): boolean {
    return JSON.stringify(current) !== JSON.stringify(original);
}
  
/**
 * Возвращает объект, содержащий только измененные поля
 */
export function getChangedValues<T extends Record<string, any>>(current: T, original: T): Partial<T> {
    const changes: Partial<T> = {};
    
    Object.keys(current).forEach(key => {
        const typedKey = key as keyof T;
        if (current[typedKey] !== original[typedKey]) {
            changes[typedKey] = current[typedKey];
        }
    });
    
    return changes;
}

/**
 * Инициализирует настройки из данных пользователя с значениями по умолчанию
 */
export function initializeSettings<T extends Record<string, any>>(
    userData: Record<string, any> | null | undefined, 
    defaults: T
): T {
    if (!userData) return { ...defaults };
    
    const result = { ...defaults };
    
    // Копируем значения из userData в result, если они существуют
    Object.keys(defaults).forEach(key => {
        const typedKey = key as keyof T;
        if (userData[key] !== undefined && userData[key] !== null) {
            result[typedKey] = userData[key];
        }
    });
    
    return result;
}